<div #carousel *ngIf="achievementData && achievementData.length && genericCarousel"
  class="genericCarousel position-relative"
  [ngClass]="{'singleItemCarousel':achievementData.length ==1, 'productCarousel':isProductCarousel }">
  <owl-carousel-o [options]="genericOptions">
    <ng-container *ngFor="let slide of achievementData">
      <ng-template carouselSlide >
        <div *ngIf="slide.image && !slide.price && !slide.postTitle " class="productImgContainer">
          <a [href]="slide.link">
            <img width="75" height="75" [src]="slide.image" loading="lazy" [alt]="slide.altTag" />
          </a>
        </div>
        <p *ngIf="isEshop" class="description text-transform-none" Style="width:260px;" [ngClass]="centered ? 'text-center' : 'text-left'">
          {{slide.altTag}}</p>
        <img *ngIf="slide.postTitle" class="blogImg" width="75" height="75" [src]="slide.image"
          alt="BlogImg | Luminous">
        <div *ngIf="slide.price && !isCategoryCarousel" class="productImgContainer" (click)="onImageClick(slide)"
         >
          <a [routerLink]="getProductLink(slide)">
            <img loading="lazy" [src]="slide.image" width="75" height="75"
              [alt]="slide.altTag ? slide.altTag : 'product-image'">
          </a>
        </div>
        <div *ngIf="isCategoryCarousel" class="productImgContainer" >
          <a [routerLink]="getProductLink(slide)" (click)="onCatClick()">
            <img loading="lazy" [src]="slide.image" width="75" height="75"
              [alt]="slide.altTag?slide.altTag:'product-image'">
          </a>
        </div>
        <iframe class="cst-video" *ngIf="slide.embededLink" [src]="slide.embededLink | safe"
          title="YouTube video player"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowfullscreen></iframe>
        <h4 *ngIf="slide.title || slide.videoTitle || slide.postTitle" class="title text-transform-none"
          [ngClass]="{'postTitle':slide.postTitle}">
          {{slide.title?slide.title:slide.videoTitle?slide.videoTitle:slide.postTitle?slide.postTitle:''}}
        </h4>
        <p *ngIf="slide.description" class="description text-transform-none"
          [ngClass]="centered ? 'text-center' : 'text-left'">
          {{slide.description?slide.description:slide.postDescription?slide.postDescription:''}}
        </p>
        <div *ngIf="slide.postDescription" class="description postDescription textJustify"
          [ngClass]="centered ? 'text-center' : 'text-left'"
          [innerHtml]="((slide.postDescription?slide.postDescription:'') | truncateStr:[108] |safehtml )">
        </div>
        <p *ngIf="slide.price && !slide.isProductNot" class="title mt-3">
          ₹ {{slide.price | number:'1.2-2'}}
          <span class="disclaimer">(Incl. all taxes)</span>
        </p>
        <div class="dateContainer">
          <span *ngIf="slide.postingDate" class="date">
            {{ (slide.postingDate ? slide.postingDate:'' ) | date: 'dd/MM/YY' }}
          </span>
          <a [routerLink]="('/blog/post/'+utils.createNameForUrl(slide.postTitle)+'/'+slide.postId)"
            *ngIf="slide.postLink" class="nextLinkWithArrow">
            {{ slide.postLink ? 'Read More':'Learn More' }}
          </a>
        </div>
      </ng-template>
    </ng-container>
  </owl-carousel-o>
</div>

<div #carousel class="custom-carousel position-relative"
  *ngIf="carouselSlideData && carouselSlideData.length && !genericCarousel && !isPDPCarousel && !frequentlyBought && !isOurLeaderCarousel">
  <owl-carousel-o [options]="customOptions">
    <ng-container *ngFor="let slide of carouselSlideData">
      <ng-template carouselSlide>
        <img class="cursorDefault" width="75" height="75" [src]="slide.icon" [alt]="slide.icon" loading="lazy">
        <h5 class="title heading5">{{slide.title}}</h5>
        <p class="description">{{slide.description}}</p>
      </ng-template>
    </ng-container>
  </owl-carousel-o>
</div>

<div #carousel class="custom-carousel position-relative ourLeadersSection"
  *ngIf="carouselSlideData && carouselSlideData.length && isOurLeaderCarousel">
  <owl-carousel-o [options]="customOptionsForOurLeaderSection">
    <ng-container *ngFor="let data of carouselSlideData">
      <ng-template carouselSlide>
        <div class="tiles" [ngClass]="{'flipOnHover':data.linkedInUrl}">
          <img loading="lazy" class="cursorDefault" width="75" height="75" *ngIf="data.image" [src]="data.image" loading="lazy"
            alt={{data.imageAltTag}}>
          <img loading="lazy" class="cursorDefault" width="75" height="75" *ngIf="!data.image" [src]="environment?.blobUrl+'/assets/icons/user.svg'"
            alt="Person | Luminous">
          <div class="nameContainer">
            <p class="name">{{data.name}}</p>
            <p class="designation">{{data.designation}}</p>
          </div>
        </div>
        <a class="linkedInContainer" [href]="data.linkedInUrl">
          <div class="bg-linkedin"></div>
        </a>
      </ng-template>
    </ng-container>
  </owl-carousel-o>
</div>

<div #carousel *ngIf="achievementData && achievementData.length && isPDPCarousel"
  class="genericCarousel position-relative"
  [ngClass]="{'singleItemCarousel':achievementData.length ==1, 'productCarousel':isProductCarousel }">
  <owl-carousel-o [options]="genericOptions">
    <ng-container *ngFor="let slide of achievementData">
      <ng-template carouselSlide>
        <div class="productImgContainer">
          <a [routerLink]="getProductLink(slide,true)">
            <img width="75" height="75" [src]="slide.featureImageFileUrl" loading="lazy"
              [alt]="slide.featureImageAltTag?slide.featureImageAltTag:'product-image'"
              (click)="onValueEmit(slide.productGuidId,slide.productName)" />
          </a>
        </div>
        <p *ngIf="slide.productName" class="description text-transform-none"
          [ngClass]="centered ? 'text-center' : 'text-left'">
          {{slide.productName?slide.productName:'N/A'}}</p>
        <p *ngIf="slide.productMRP" class="title mt-3">₹ {{(slide.productMRP || 0) | number:'1.2-2'}}<span
            class="disclaimer">(Incl. all taxes)</span>
        </p>
        <div class="dateContainer">
          <span *ngIf="slide.date" class="date">{{slide.date ? slide.date:12/02/22}}</span>
          <a href="" *ngIf="slide.linkText" class="nextLinkWithArrow">{{slide.linkText ? slide.linkText:
            'Learn More'}}</a>
        </div>
      </ng-template>
    </ng-container>
  </owl-carousel-o>
</div>

<div #carousel *ngIf="achievementData && achievementData.length && frequentlyBought"
  class="genericCarousel position-relative"
  [ngClass]="{'singleItemCarousel':achievementData.length ==1, 'productCarousel':isProductCarousel }">
  <owl-carousel-o [options]="genericOptions">
    <ng-container *ngFor="let slide of achievementData">
      <ng-template carouselSlide>
        <div class="productImgContainer">
          <a [routerLink]="getProductLink(slide,true)">
            <img *ngIf="slide.featureImageUniqueFileName" [src]="slide.featureImageUniqueFileName"
            loading="lazy"
              (click)="onValueEmit(slide.productGuidId,slide.productName)"
              [alt]="slide.featureImageAltTag? slide.featureImageAltTag: 'product-image'" />
          </a>
        </div>
        <p *ngIf="slide.productName" class="description text-transform-none"
          [ngClass]="centered ? 'text-center' : 'text-left'">
          {{slide.productName?slide.productName:'N/A'}}</p>
        <p *ngIf="slide.productMRP" class="title mt-3">₹ {{(slide.productMRP || 0) | number:'1.2-2'}}<span
            class="disclaimer">(Incl. all taxes)</span>
        </p>
        <div class="dateContainer">
          <span *ngIf="slide.date" class="date">{{slide.date ? slide.date:12/02/22}}</span>
          <a href="" *ngIf="slide.linkText" class="nextLinkWithArrow">{{slide.linkText ? slide.linkText:
            'Learn More'}}</a>
        </div>
      </ng-template>
    </ng-container>
  </owl-carousel-o>
</div>
<div [innerHtml]="structuredData"></div>
